/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SeoLink_linkData = {
    readonly path: string | null;
    readonly isLinkable: boolean | null;
    readonly " $refType": "SeoLink_linkData";
};
export type SeoLink_linkData$data = SeoLink_linkData;
export type SeoLink_linkData$key = {
    readonly " $data"?: SeoLink_linkData$data;
    readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SeoLink_linkData",
  "type": "LinkData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '55a81d229ac5e2ca87225e8d0dbdd2a0';
export default node;
